import { render, staticRenderFns } from "./allotAuthorize.vue?vue&type=template&id=234ea494&"
import script from "./allotAuthorize.vue?vue&type=script&lang=js&"
export * from "./allotAuthorize.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\project\\文化宫\\code\\whg\\Web\\Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('234ea494')) {
      api.createRecord('234ea494', component.options)
    } else {
      api.reload('234ea494', component.options)
    }
    module.hot.accept("./allotAuthorize.vue?vue&type=template&id=234ea494&", function () {
      api.rerender('234ea494', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/system/role/allotAuthorize.vue"
export default component.exports